export default __webpack_public_path__ + "static/media/create-user-on.14cdae89.svg";